import { Input } from '@wix/design-system';
import React__default, { useState } from 'react';
import { isValidUrl } from './utils.js';
import 'wix-rich-content-common';

const LinkInput = ({
  value,
  onChange,
  placeholder,
  dataHook,
  inputRef,
  setSubmittedInvalidUrl
}) => {
  const [url, setUrl] = useState(value);
  const handleInputChange = (event) => {
    const value2 = event.target.value;
    setSubmittedInvalidUrl(false);
    setUrl(value2);
    onChange(value2);
  };
  const handleBlur = () => {
    if (url && !isValidUrl(url)) {
      setSubmittedInvalidUrl(true);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Input,
    {
      inputRef: (ref) => {
        if (inputRef) {
          inputRef.current = ref;
        }
      },
      type: "url",
      placeholder,
      value: url,
      onChange: handleInputChange,
      dataHook,
      onBlur: handleBlur
    }
  );
};

export { LinkInput };
//# sourceMappingURL=link-input.js.map
